import { Space } from "@mantine/core";
import { CTABannerSingle } from "../CTABannerSingle/CTABannerSingle";
import { FeatureCardList } from "../FeatureCardList/FeatureCardList";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { HeroTitle } from "../HeroTitle/HeroTitle";
import { VideoHero } from "../VideoHero/VideoHero";

export default function BodyContent(): React.JSX.Element {
  
  return (
    <>
      <HeroTitle />
      <Space h="xl" />
      <Space h="xl" />
      <VideoHero />
      <Space h="xl" id="features" />
      <Space h="xl" />
      <FeatureCardList />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" id="pricing" />
      <CTABannerSingle />
      <Space h="xl" />
      <Space h="xl" />
      <FooterLinks />
    </>
  );
}
